/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgHelp = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1408 632q0-78-31-146t-83-120-123-80-147-30q-80 0-150 30t-122 82-82 122-30 150q0 26-19 45t-45 19q-32 0-48-22t-16-52q0-104 41-195t112-160 163-107 196-40q103 0 195 39t163 108 112 159 42 196q0 81-17 141t-49 111-77 95-103 96q-29 26-57 50t-54 53q-33 36-51 69t-27 68-11 74-2 85q0 26-19 45t-45 19q-22 0-34-8t-19-21-9-31-2-34v-34q0-79 19-139t50-109 72-88 83-76 82-73 71-78 51-94 20-119zM928 1824q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28q-40 0-68-28t-28-68z"
    }));
export default SvgHelp;
